export default "__VITE_ASSET__CDn5o6Tt__"